import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = () => {
  const ticket = useSelector((state) => state.ticket);

  // Verificamos si hay un usuario válido
  const isAuth =
    ticket &&
    (ticket.Retorno == 0 ||
      ticket.Retorno == 1 ||
      ticket.Retorno == 2 ||
      ticket.Retorno == 3);

  // Si está autorizado, renderiza la ruta hija (Outlet)
  // Si no, redirige al login ("/")
  return isAuth ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
